import { useState, useEffect } from 'react';
import { useCookieConsent } from './useCookieConsent';

export type Theme = 'light' | 'dark' | 'system';

export const useTheme = () => {
  const { functional } = useCookieConsent();
  const [theme, setTheme] = useState<Theme>('light');

  // Load theme from localStorage if functional cookies are enabled
  useEffect(() => {
    if (functional) {
      const savedTheme = localStorage.getItem('theme') as Theme;
      if (savedTheme) {
        setTheme(savedTheme);
      }
    } else {
      // If functional cookies are disabled, default to light theme
      setTheme('light');
    }
  }, [functional]);

  // Apply theme to document
  useEffect(() => {
    const root = window.document.documentElement;
    
    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      root.classList.remove('light', 'dark');
      root.classList.add(systemTheme);
    } else {
      root.classList.remove('light', 'dark');
      root.classList.add(theme);
    }
  }, [theme]);

  const updateTheme = (newTheme: Theme) => {
    setTheme(newTheme);
    
    // Only save to localStorage if functional cookies are enabled
    if (functional) {
      localStorage.setItem('theme', newTheme);
    }
  };

  return {
    theme,
    setTheme: updateTheme,
    canPersist: functional,
  };
};